import {
  Button,
  Form,
  Input,
  Drawer,
  DatePicker,
  Modal,
  Row,
  Col,
  Empty,
} from "antd";
import dayjs from "dayjs";
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faAngleLeft,
  faArrowUp,
  faArrowDown,
} from "@fortawesome/free-solid-svg-icons";
import ChooseHotel from "../Common/ChooseHotel";
import HotelItem from "../Common/HotelItem";
import "react-calendar/dist/Calendar.css";
import locale from "antd/es/date-picker/locale/vi_VN";
import "moment/locale/vi"; // Import locale tiếng Việt
import CalendarCustom from "../Common/Calendar/CalendarCustom";
import CustomInputNumber from "../Common/CustomInputNumber";
import { useBookingLogic } from "../../hooks/useBookingLogic";
import _ from "lodash";

const Booking = ({ setLoading, loading, setStep }) => {
  const {
    form,
    countries,
    filterCountries,
    chooseAddStep,
    setChooseAddStep,
    hotels,
    openChooseHotel,
    setOpenChooseHotel,
    hotelSelected,
    setHotelSelected,
    provinces,
    filterProvinces,
    searched,
    addPrice,
    openDrawerChooseAdd,
    setOpenDrawerChooseAdd,
    openDrawerChooseHotel,
    setOpenDrawerChooseHotel,
    searchTerm,
    setSearchTerm,
    searchTermHotel,
    setSearchTermHotel,
    loadingLocation,
    displayHotels,
    valueCalendar,
    openCalendar,
    setOpenCalendar,
    typeCalendar,
    minDateCalendar,
    sortBy,
    filterHotel,
    filter,
    hotelSearch,
    onOpenChange,
    setValue,
    handleGetListHotelAvailable,
    handleSelectAdd,
    handleSortPriceHotel,
    handleSortStarHotel,
    setFormValueAndSearch,
  } = useBookingLogic({ setLoading, setStep });

  const [modal, contextHolder] = Modal.useModal();

  return (
    <div className="flex flex-col items-center mt-[0px] booking absolute left-1/2 transform -translate-x-1/2 w-full pb-[64px] top-[180px]">
      <CalendarCustom
        openCalendar={openCalendar}
        setOpenCalendar={setOpenCalendar}
        typeCalendar={typeCalendar}
        form={form}
        valueCalendar={valueCalendar}
        setValue={setValue}
        minDate={minDateCalendar}
      />

      <Form
        form={form}
        onFinish={handleGetListHotelAvailable}
        layout="vertical"
        onFinishFailed={(values) => {
          console.log(values, "values");
        }}
        initialValues={{
          departDate: dayjs(),
          returnDate: dayjs().add(1, "day"),
          startNumber: 0,
        }}
        className="w-[92%] mt-4"
      >
        <div
          style={{
            boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.25)",
          }}
          className="rounded-2xl bg-[#cce9ef]"
        >
          <div
            style={{
              boxShadow: "0px 2px 2px 0px rgba(0, 0, 0, 0.25)",
            }}
            className=" bg-white p-4 rounded-2xl"
          >
            <div className="grid grid-cols-2 gap-4">
              <div className="flex flex-col">
                <div className="text-[#22313F] text-[14px] my-1 font-medium">
                  Điểm đến
                </div>
                <Input
                  placeholder="Địa điểm"
                  className="h-[48px] bg-[#f5f6f6] font-normal text-[16px] text-[#333333] address-input focus:border-primary"
                  readOnly
                  prefix={<img src="/images/icon-location.svg" alt="" />}
                  onClick={() => {
                    setOpenDrawerChooseAdd(true);
                  }}
                  value={filter.address}
                />
              </div>

              <div className="flex flex-col">
                <div className="text-[#22313F] text-[14px] my-1 font-medium">
                  Tên khách sạn
                </div>
                <Input
                  placeholder="Tên khách sạn"
                  className="h-[48px] bg-[#f5f6f6] font-normal text-[16px] text-[#333333] address-input focus:border-[#01ad53]"
                  readOnly
                  onClick={() => {
                    setOpenDrawerChooseHotel(true);
                  }}
                  value={_.get(_.find(hotels, (c) => c.id === hotelSearch), "name") || "Tất cả"}
                />
              </div>
            </div>

            <Row gutter={12} className="my-4">
              <Col span={12}>
                <div className="text-[#22313F] text-[14x] mb-2 font-medium">
                  Ngày nhận phòng
                </div>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn ngày nhận phòng!",
                    },
                  ]}
                  name="departDate"
                  className="w-full mb-0"
                >
                  <DatePicker
                    className="w-full h-[48px]"
                    placeholder="Chọn ngày"
                    format="DD/MM/YYYY"
                    minDate={dayjs()}
                    allowClear={false}
                    locale={locale} // Thiết lập locale tiếng Việt
                    suffixIcon={
                      <img
                        src={"/images/date.svg"}
                        className="w-[14px]"
                        alt=""
                      />
                    }
                    open={false}
                    onOpenChange={() => onOpenChange("departDate")}
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <div className="text-[#22313F] text-[14px] mb-2 font-medium">
                  Ngày trả phòng
                </div>
                <Form.Item
                  rules={[
                    {
                      required: true,
                      message: "Vui lòng chọn ngày trả phòng!",
                    },
                  ]}
                  name="returnDate"
                  className="w-full mb-0"
                >
                  <DatePicker
                    className="w-full h-[48px]"
                    placeholder="Chọn ngày"
                    format="DD/MM/YYYY"
                    minDate={dayjs()}
                    allowClear={false}
                    locale={locale} // Thiết lập locale tiếng Việt
                    suffixIcon={
                      <img
                        src={"/images/date.svg"}
                        className="w-[14px]"
                        alt=""
                      />
                    }
                    open={false}
                    onOpenChange={() => onOpenChange("returnDate")}
                  />
                </Form.Item>
              </Col>
            </Row>

            <div className="flex w-full gap-4 justify-between mb-2">
              <div className="w-1/3">
                <CustomInputNumber
                  form={form}
                  name="numAdults"
                  label={
                    <span className="mb-1 text-[14px] font-medium text-[#22313F] flex gap-2">
                      <img src="/images/aldult.svg" alt="" />
                      Người lớn
                    </span>
                  }
                  min={1}
                  max={10}
                  defaultValue={1}
                />
              </div>

              <div className="w-1/3">
                <CustomInputNumber
                  form={form}
                  name="numChilds"
                  label={
                    <span className="mb-1 text-[14px] font-medium text-[#22313F] flex gap-2">
                      <img src="/images/child.svg" alt="" />
                      Trẻ em
                    </span>
                  }
                  min={0}
                  max={10}
                  defaultValue={1}
                />
              </div>

              <div className="w-1/3">
                <CustomInputNumber
                  form={form}
                  name="numRooms"
                  label={
                    <span className="mb-1 text-[14px] font-medium text-[#22313F] flex gap-2">
                      <img src="/images/icon-room.svg" alt="" />
                      Số phòng{" "}
                    </span>
                  }
                  min={1}
                  max={1000}
                  defaultValue={1}
                />
              </div>
            </div>

            <Button
              type="primary"
              htmlType="submit"
              className="w-full h-[48px] mt-4 bg-primary hover:bg-primary"
            >
              <span className="text-[16px] font-semibold">Tìm kiếm</span>
            </Button>
          </div>
          <div className="py-5 px-4 rounded-ee-2xl rounded-es-2xl flex justify-between items-center">
            <span className="font-semibold"> Bạn đã có mã đơn hàng? </span>
            <Button
              onClick={() => setStep("history")}
              variant="outlined"
              className="bg-transparent rounded-lg w-[113px] h-[36px] border-[1px] border-solid border-[#2D5E8E] text-[#2D5E8E]"
            >
              <span className="text-[16px] font-semibold">Tra cứu ngay</span>
            </Button>
          </div>
        </div>
      </Form>

      <div className="text-center mt-4">
        <span className="text-[#808080] font-normal">
          Hotline hỗ trợ khách hàng{" "}
        </span>
        <a href="tel:1900255585" className="font-bold text-primary text-[16px]">
          1900255585
        </a>
      </div>
      {searched && displayHotels.length > 0 && (
        <div
          className="bg-white p-4 text-center items-center flex mt-4 rounded-[12px] w-[92%] gap-3"
          style={{
            boxShadow: "0px 4px 4px 4px rgba(0, 0, 0, 0.25)",
            justifyContent: "space-around",
          }}
        >
          {/* <Dropdown menu={menuSortTime}> */}
          <Button
            className="bg-white border-[#d9d9d9] text-white focus:bg-white hover:bg-white rounded-[20px]"
            onClick={() => handleSortPriceHotel()}
          >
            {sortBy === "price:asc" && (
              <FontAwesomeIcon
                icon={faArrowUp}
                className="w-[14px]"
                color="#0064D2"
              />
            )}
            {sortBy === "price:desc" && (
              <FontAwesomeIcon
                icon={faArrowDown}
                className="w-[14px]"
                color="#0064D2"
              />
            )}
            <span className="text-black">Giá</span>
          </Button>

          <Button
            className="bg-white border-[#d9d9d9] text-white focus:bg-white hover:bg-white rounded-[20px]"
            onClick={() => handleSortStarHotel()}
          >
            {sortBy === "star:asc" && (
              <FontAwesomeIcon
                icon={faArrowUp}
                className="w-[14px]"
                color="#0064D2"
              />
            )}
            {sortBy === "star:desc" && (
              <FontAwesomeIcon
                icon={faArrowDown}
                className="w-[14px]"
                color="#0064D2"
              />
            )}
            <span className="text-black">Hạng khách sạn</span>
          </Button>
        </div>
      )}

      {displayHotels && displayHotels.length > 0 ? (
        <div className="mt-4 w-[92%]">
          {displayHotels.map((item, index) => (
            <HotelItem
              key={index}
              setOpenChooseHotel={setOpenChooseHotel}
              data={item}
              setHotelSelected={setHotelSelected}
              addPrice={addPrice}
            />
          ))}
        </div>
      ) : (
        <>
          {!loading && searched && displayHotels.length === 0 && (
            <div className="flex flex-col w-[92%] items-center mt-[48px]">
              <div className="text-[24px] text-[#0064D2] font-bold text-center mb-2">
                Không tìm thấy khách sạn trên Ipass
              </div>
              <div className="mb-4 text-center text-[#0064D2]">
                Hiện tại <span className="font-bold">Ipass</span> chưa cập nhật
                phòng khách sạn tại{" "}
                <span className="font-bold">{filter.address}</span> từ ngày
                <span className="font-bold">
                  {" "}
                  {dayjs(form.getFieldValue("departDate")).format("DD-MM-YYYY")}
                </span>{" "}
                đến ngày
                <span className="font-bold">
                  {" "}
                  {dayjs(form.getFieldValue("returnDate")).format("DD-MM-YYYY")}
                </span>
              </div>
              <div className="mb-4 text-center text-[#0064D2]">
                Xin quý khách vui lòng tìm phòng với ngày khác hoặc thay đổi địa
                điểm tìm kiếm.
              </div>
              <Empty description={""} />
            </div>
          )}
        </>
      )}
      {/* 
      {displayHotels.length > 0 && (
        <div className="flex items-center justify-center">
          <Pagination
            current={currentPage}
            className="my-4"
            total={displayHotels.length}
            onChange={(page) => {
              // getPaginatedHotels(hotels, page);
              setCurrentPage(page);
            }}
            pageSize={pageSize}
            showSizeChanger={false}
            showQuickJumper={false}
          />
        </div>
      )} */}
      {openChooseHotel && (
        <ChooseHotel
          hotelSelected={hotelSelected}
          open={openChooseHotel}
          addPrice={addPrice}
          setOpenChooseHotel={setOpenChooseHotel}
          setLoading={setLoading}
          formSearch={form}
          setHotelSelected={setHotelSelected}
          filterSearch={filter}
        />
      )}

      {openDrawerChooseHotel && (
        <div className="location">
          <Drawer
            title={
              <h1 className="text-lg font-bold text-white">Chọn khách sạn</h1>
            }
            placement="bottom"
            open={openDrawerChooseHotel}
            onClose={() => {
              setTimeout(() => {
                setOpenDrawerChooseHotel(false);
              }, 0);
            }}
            height="100vh"
          >
            <div className="custom-scroll pb-[64px]">
              <Input
                placeholder="Tìm kiếm khách sạn"
                value={searchTermHotel}
                onChange={(e) => {
                  setSearchTermHotel(e.target.value);
                }}
                className="mb-2"
              />
              <div className="overflow-auto airport-list">
                {filterHotel.length > 0 ? (
                  <>
                    <h4 className="mb-2 font-semibold text-md text-primary">
                      Chọn khách sạn
                    </h4>
                    <div className="flex gap-2.5 flex-wrap">
                      {filterHotel.map((c) => (
                        <div
                          key={c.id}
                          className="h-8 flex items-center rounded-lg px-2 bg-[#EDF2F7]"
                          onClick={() => handleSelectAdd(c.id, "hotel")}
                        >
                          {c?.name}
                        </div>
                      ))}
                    </div>
                  </>
                ) : (
                  <Empty description={"Không có dữ liệu"} />
                )}
              </div>
            </div>
            {contextHolder}
          </Drawer>
        </div>
      )}

      {openDrawerChooseAdd && (
        <div className="location">
          <Drawer
            title={
              <h1 className="text-lg font-bold text-white">
                {chooseAddStep === 1 ? "Chọn đất nước" : "Chọn tỉnh thành"}
              </h1>
            }
            placement="bottom"
            open={openDrawerChooseAdd}
            onClose={() => {
              setTimeout(() => {
                setOpenDrawerChooseAdd(false);
              }, 0);
            }}
            height="100vh"
            loading={loadingLocation}
          >
            {chooseAddStep === 2 && (
              <div
                className="w-full bg-white  text-[#0064d2] mb-4"
                onClick={() => setChooseAddStep(1)}
              >
                <FontAwesomeIcon icon={faAngleLeft} color="#0064d2" />
                <span className="text-[16px]">Quay lại</span>{" "}
              </div>
            )}
            <div className="custom-scroll pb-[64px]">
              {(chooseAddStep === 1 && countries.length > 0) ||
                (chooseAddStep === 2 && provinces.length > 0) ? (
                <Input
                  placeholder="Tìm kiếm địa điểm"
                  value={searchTerm}
                  onChange={(e) => {
                    setSearchTerm(e.target.value);
                  }}
                  className="mb-2"
                />
              ) : (
                <Empty description={"Không có dữ liệu"} />
              )}

              <div className="overflow-auto airport-list">
                {filterCountries.length > 0 && chooseAddStep === 1 && (
                  <>
                    <h4 className="mb-2 font-semibold text-md text-primary">
                      Chọn đất nước
                    </h4>
                    <div className="flex gap-2.5 flex-wrap">
                      {filterCountries.map((c) => (
                        <div
                          key={c.id}
                          className="h-8 flex items-center rounded-lg px-2 bg-[#EDF2F7]"
                          onClick={() => handleSelectAdd(c.id, "country")}
                        >
                          {c?.name}
                        </div>
                      ))}
                    </div>
                  </>
                )}

                {filterProvinces.length > 0 && chooseAddStep === 2 && (
                  <div className="mt-4">
                    <h4 className="mb-2 font-semibold text-md text-primary">
                      Tỉnh/Thành phố
                    </h4>
                    <div className="flex gap-2.5 flex-wrap">
                      {filterProvinces.map((item) => (
                        <div
                          key={item.id}
                          className="h-8 flex items-center rounded-lg px-2 bg-[#EDF2F7]"
                          onClick={() => handleSelectAdd(item.id, "province")}
                        >
                          {item?.name}
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
            {contextHolder}
          </Drawer>
        </div>
      )}
    </div>
  );
};

export default Booking;
